import clsx from 'clsx';
import React from 'react';

import s from './ButtonGroup.module.less';

export enum Justify {
  start = 'flex-start',
  end = 'flex-end',
  center = 'center',
  'spece-around' = 'space-around',
  'space-between' = 'space-between',
}

export interface ButtonGroupRowProps extends React.HTMLAttributes<HTMLDivElement> {
  justify?: keyof typeof Justify;
  gutter?: number;
}

// Explicit, PINNED per-value map. Keying through this map (NOT a `justify_${justify}`
// template lookup) GUARANTEES every enum value — including the hyphenated `space-between`
// and the verbatim `spece-around` typo — resolves to a DEFINED class rather than undefined
// (a MIG-04 silent failure). The 'spece-around' KEY is preserved verbatim to match the
// consumer-passed value; only the mapped class VALUE is a clean identifier. Typed
// `Record<Justify, string>` so tsc statically proves every enum member has an entry.
export const justifyClassMap: Record<keyof typeof Justify, string> = {
  start: 'justifyStart',
  end: 'justifyEnd',
  center: 'justifyCenter',
  'spece-around': 'justifySpaceAround',
  'space-between': 'justifySpaceBetween',
};

export const ButtonGroupRow: React.FC<ButtonGroupRowProps> = (props) => {
  const { justify, gutter, className, children, ...rest } = props;

  return React.createElement(
    'div',
    {
      ...rest,
      className: clsx(s.root, className, justify && s[justifyClassMap[justify]]),
      style: gutter !== undefined ? ({ '--gutter': `${gutter}px` } as React.CSSProperties) : undefined,
    },
    children,
  );
};
